import { BehaviorSubject } from 'rxjs';
import { Injectable, inject } from '@angular/core';
import { DateTime } from 'luxon';
import { ApiKeyCurrentUserService } from '../../model/api-key/api-key.service';
import { QuerySearch } from '../../model/query-search.model';
import {
  CriterionCombinedType,
  CriteriaSimple,
} from '../search/search-filter/criterion/criteria/criteria.model';
import { ApiKeyFields } from '../../model/api-key/api-key.fields';
import { Operators } from '../../model/operators';

export interface ExpirationState {
  state: 'error' | 'warning';
  message: string;
  color: string;
  cy: string;
}

@Injectable({
  providedIn: 'root',
})
export class HighlightApiKeyService {
  private unreadSubject = new BehaviorSubject<number>(0);
  unread$ = this.unreadSubject.asObservable();
  service = inject(ApiKeyCurrentUserService);

  constructor() {
    this.checkExpires();
  }

  checkExpires(): void {
    const next7Days = DateTime.now().plus({ days: 7 }).toISO();
    const apiKeyFields = new ApiKeyFields();
    const query = new QuerySearch(
      CriterionCombinedType.OR,
      [
        new CriteriaSimple(apiKeyFields.expirationDate.name, Operators.LESS_THAN, next7Days),
        new CriteriaSimple(apiKeyFields.expirationDate.name, Operators.EQUAL, next7Days),
      ],
      [apiKeyFields.id.name, apiKeyFields.expirationDate.name],
      -1,
      0
    );
    this.service.search(query).subscribe(res => {
      this.unreadSubject.next(res?.count || 0);
    });
  }

  isExpired(expirationDate: string): ExpirationState | null {
    const date = DateTime.fromISO(expirationDate);
    const now = DateTime.now();
    if (now.valueOf() >= date.valueOf()) {
      return {
        state: 'error',
        message: $localize`Key is expired`,
        color: 'error',
        cy: 'expired-icon',
      };
    }

    if (now.plus({ days: 7 }).valueOf() >= date.valueOf()) {
      return {
        state: 'warning',
        message: $localize`Key expires in less than 7 days`,
        color: 'warn',
        cy: 'warning-icon',
      };
    }

    return null;
  }
}
